module.exports = require("lodash/isString");


//////////////////
// WEBPACK FOOTER
// external "lodash/isString"
// module id = 41
// module chunks = 0